import { Injectable, OnInit } from '@angular/core';
import { ReportType, SubscriptionManagementApiModel, SubscriptionRowNode } from 'src/app/admin/Subscription/subscription-management-model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionService {
    constructor(
        private _apiService: CVApiService
    ) { }

    //#region REST Functions
    public async getSubscriptions(): Promise<SubscriptionManagementApiModel> {
        try {
            const response = await this._apiService.get<SubscriptionManagementApiModel>("/api/v1/subscriptions");
            if (response.status_code == 200)
                return response.data;
            throw response;
        }
        catch (err) {
            console.error("Failed getting subscriptions.");
            throw err;
        }
    }

    public async editSubscription(subscription: SubscriptionRowNode, subscriptionType: ReportType): Promise<boolean> {
        const data = JSON.stringify({
            ID: subscription.ID,
            subscriptionType,
            Recipients: subscription.Recipients,
        });
        try {
            const response = await this._apiService.put("/api/v1/subscription", data);
            if (response.status_code < 200 || response.status_code >= 300)
                throw response;
            return true;
        }
        catch (err) {
            console.error(`Failed to edit subscription ${subscription.Name}.`);
            return false;
        }
    }

    public async exportSubscription(subscriptionId: number, subscriptionType: ReportType): Promise<string> {
        try {
            const response = await this._apiService.get<string>(`/api/v1/subscription/export/${subscriptionId}/${subscriptionType}`);
            if (response.status_code == 200)
                return response.data;
            throw response;
        }
        catch (err) {
            console.error("Failed to export subscription.");
            throw err;
        }
    }

    public async deleteSubscription(subscriptionId: number, subscriptionType: ReportType): Promise<boolean> {
        try {
            const response = await this._apiService.delete(`/api/v1/subscription/${subscriptionId}/${subscriptionType}`);
            if (response.status_code < 200 || response.status_code >= 300)
                throw response;
            return true;
        }
        catch (err) {
            console.error("Failed to delete subscription.");
            return false;
        }
    }
    //#endregion

    public exportBulk(filterValue: string, legacy: boolean, orderBy: string = "") {
        const link = document.createElement('a');
        const url = "../Reports/GenericExportExcel.aspx?source=subscriptionmanagement";
        link.setAttribute('href',
            `${url}&filtercustom=${filterValue}&filtertype=${(legacy) ? -1 : 2}&filterfrequency=-1&orderby=${orderBy}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
}
